import React from 'react';
import { Menu } from '@milanote/roma';
import { cx } from '@milanote/roma/utils';
import { GridListItem } from 'react-aria-components';
import { Plus } from '@untitledui/icons';

import { CREATE_LABEL } from '../hooks/useLabelListSelection';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

const styles = {
    sm: {
        itemSize: 'sm',
        leadingIconWrapper: 'mx-0.5',
    },
    lg: {
        itemSize: 'lg',
        leadingIconWrapper: '',
    },
} as const;

type Props = {
    searchString: string;
    size?: keyof typeof styles;
};

const CreateLabelListItem: React.FC<Props> = ({ searchString, size = 'sm' }) => {
    const translate = useTranslator('popup', 'labels.menu');
    const sizeStyles = styles[size];

    if (!searchString) return null;

    return (
        <GridListItem
            id={CREATE_LABEL}
            textValue={searchString}
            className={cx('CreateLabelListItem', 'w-full py-1 outline-hidden')}
        >
            {(state) => (
                <Menu.Base.ItemStructured
                    leading={
                        /* have to manually add some margin to align with the checkboxes below */
                        <div data-icon="leading" className={sizeStyles.leadingIconWrapper}>
                            <Plus />
                        </div>
                    }
                    label={translate('createLabel', { searchString })}
                    isSelected={state.isSelected}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={state.isHovered}
                    className="mx-0.5 cursor-pointer"
                    size={sizeStyles.itemSize}
                />
            )}
        </GridListItem>
    );
};

export default CreateLabelListItem;
